module.exports = __webpack_public_path__ + "img/公司荣誉.93e2e558.jpg";